import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import { BrowserRouter } from "react-router-dom";
import useAuthentication from "./hooks/useAuthentication";
import AuthNavigator from "./navigation/AuthNavigator";
import DashboardNavigator from "./navigation/DashboardNavigator";
import LoadingScreen from "./pages/LoadingScreen";

const theme = createTheme({
  palette: {
    common: {
      black: "#000",
      white: "#fff",
    },
    background: {
      paper: "#fff",
      default: "#fafafa",
    },
    primary: {
      light: "rgba(252, 172, 43, 1)",
      main: "rgba(255, 157, 0, 1)",
      dark: "rgba(255, 140, 0, 1)",
      contrastText: "#fff",
    },
    secondary: {
      light: "rgba(255, 156, 25, 0.67)",
      main: "rgba(255, 145, 0, 1)",
      dark: "rgba(255, 128, 0, 1)",
      contrastText: "#fff",
    },
    error: {
      light: "#e57373",
      main: "#f44336",
      dark: "#d32f2f",
      contrastText: "#fff",
    },
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.54)",
      disabled: "rgba(0, 0, 0, 0.38)",
      hint: "rgba(0, 0, 0, 0.38)",
    },
  },
});

function App() {
  const [isAuthenticated, isLoading] = useAuthentication();

  const setNavigator = () => {
    if (isLoading) {
      return <LoadingScreen/>
    }
    if (isAuthenticated) {
      return <DashboardNavigator />;
    }
    return <AuthNavigator />;
  };

  const routes = setNavigator();
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>{routes}</ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
